/* menu drawer: phone swaps panels, desktop opens a second column */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(min-width: 1001px)') : null;
  function desktop() { return !!(mq && mq.matches); }
  function menu() { return document.getElementById('site-menu'); }
  function show(name) {
    var m = menu(); if (!m) return;
    var panels = m.querySelectorAll('[data-menu-panel]');
    var i;
    if (desktop()) {
      for (i = 0; i < panels.length; i++) panels[i].hidden = false;
      if (name === 'shop') m.classList.add('is-sub'); else m.classList.remove('is-sub');
    } else {
      m.classList.remove('is-sub');
      for (i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-menu-panel') !== name;
      }
    }
    m.scrollTop = 0;
  }
  document.addEventListener('click', function (e) {
    var t = e.target, m = menu();
    if (!t || !t.closest || !m) return;
    var opener = t.closest('[data-menu-open]');
    if (opener && m.contains(opener)) { show(opener.getAttribute('data-menu-open')); return; }
    if (t.closest('[data-menu-back]') && m.contains(t)) { show('root'); return; }
    if (t.closest('[data-menu-close]') && m.contains(t)) {
      m.hidden = true;
      var b = document.querySelector('[data-menu-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });
  show('root');
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', function () { show('root'); });
    else if (mq.addListener) mq.addListener(function () { show('root'); });
  }
  var m0 = menu();
  if (m0 && window.MutationObserver) {
    new MutationObserver(function () { var m = menu(); if (m && m.hidden) show('root'); })
      .observe(m0, { attributes: true, attributeFilter: ['hidden'] });
  }
})();